export default __webpack_public_path__ + "_/sounds/bet_created-6c4cf91dda119e67f60eb00fd6b69f89cc1bd4d545e659744d32f60984103597.mp3";